export const MapTrackingState = {
  mapPresent: false
}